import React from 'react';
import Events from '../../../components/event';

const EventPage = () => {
  return (
    <>
      <Events />
    </>
  );
};

export default EventPage;
